// material
import Home from '../files/Home';
// ----------------------------------------------------------------------

export default function DashboardNavigator() {
  return Home();
}
